import Vue from 'vue'

import {
  ModuleInfo
} from '@/config/nameConfig'

import * as Helper from '../modules/helper/index'

export const BootUpSyncselectQuery = (moduleid) => {
  let query = `SELECT LastSync FROM ${ModuleInfo.Tables.LastSyncInfo}
    where ModuleActivationId = ${moduleid}`
  return query
}

export const selectBootUpSync = async(key) => {
  let result = await Vue.db.runquery(BootUpSyncselectQuery(key))
  return result
}

export const mergeBootUpSync = async(payload) => {
  await Vue.db.merge(ModuleInfo.Tables.LastSyncInfo, payload, ModuleInfo.Primarykey.ModuleActivationId)
}
// export const mergeSubscriptionsAppImages = (payload) => {
//   Vue.db.merge(ModuleInfo.Tables.SubscriptionsAppImages, payload, ModuleInfo.Primarykey.Id)
// }
export const selectSubscriptionsDesignSettings = (key) => {
  let result = Vue.db.fetchRows(ModuleInfo.Tables.SubscriptionsDesignSettings)
  return result
}

export const selectSubscriptionsStartPages = (key) => {
  let result = Vue.db.fetchRows(ModuleInfo.Tables.SubscriptionsStartPages)
  return result
}

export const selectSubscriptionsModules = (key) => {
  let result = Vue.db.fetchRows(ModuleInfo.Tables.SubscriptionsModules)
  return result
}

export const mergeSubscriptionsDesignSettings = async(payload) => {
  await Vue.db.merge(ModuleInfo.Tables.SubscriptionsDesignSettings, payload,
    ModuleInfo.Primarykey.Id)
}

export const mergeSubscriptionsStartPages = async(payload) => {
  await Vue.db.merge(ModuleInfo.Tables.SubscriptionsStartPages, payload,
    ModuleInfo.Primarykey.Id)
}

export const mergeSubscriptionsModules = async(payload) => {
  payload.forEach(async(module) => {
    await Vue.db.merge(ModuleInfo.Tables.SubscriptionsModules, module,
      ModuleInfo.Primarykey.Id)
  })
}

export const selectModulesTeamMembers = (key) => {
  let result = Vue.db.contitionalSelect(ModuleInfo.Tables.ModulesTeamMembers,
    ModuleInfo.Primarykey.SubscriptionModule_Id, key)
  return result
}

export const selectModulesTeamMembersPersons = (key) => {
  let result = Vue.db.contitionalSelect(ModuleInfo.Tables.ModulesTeamMembersPersons,
    ModuleInfo.Primarykey.ModulesTeamMembers_Id, key)
  return result
}

export const mergeModulesTeamMembers = async(payload) => {
  await Vue.db.merge(ModuleInfo.Tables.ModulesTeamMembers, payload,
    ModuleInfo.Primarykey.Id)
}

export const mergeModulesTeamMembersPersons = async(payload) => {
  payload.forEach(async(person) => {
    await Vue.db.merge(ModuleInfo.Tables.ModulesTeamMembersPersons, person,
      ModuleInfo.Primarykey.Id)
  })
}

export const selectModulesContentPages = (key) => {
  let result = Vue.db.contitionalSelect(ModuleInfo.Tables.ModulesContentPages,
    ModuleInfo.Primarykey.SubscriptionModule_Id, key)
  return result
}
export const selectModulesContentPagesPosts = async(key, category) => {
  let contentPages = []
  // let categoryQuery = `SELECT Id, Category
  //   FROM ModulesContentPagesPosts
  //   WHERE ModulesContentPages_Id = '${key}' GROUP BY Category`
  // console.log('categoryQuery', categoryQuery)
  // let categories = await Vue.db.runquery(categoryQuery)
  let categories = []
  if (!Helper.IsNullOrEmpty(category)) {
    categories = JSON.parse(category)
  } else {
    let categoryQuery = `SELECT Category FROM ModulesContentPagesPosts WHERE ModulesContentPages_Id = '${key}' GROUP BY Category`
    let categoryList = await Vue.db.runquery(categoryQuery)
    for (let category of categoryList) {
      categories.push(category.Category)
    }
    if(categories.length === 0) {
      categories.push('')
    }
  }
  for (let category of categories) {
    let contnetPageInfo = {
      Category: category,
      Posts: []
    }
    let postsQuery = ''
    if(categories.length === 1) {
      postsQuery = `SELECT *
          FROM ModulesContentPagesPosts
          WHERE ModulesContentPages_Id = '${key}' AND  ( Category ='${category}' OR Category ='' OR Category is null)
          ORDER BY OrderId`
    } else if (!Helper.IsNullOrEmpty(category)) {
      postsQuery = `SELECT *
          FROM ModulesContentPagesPosts
          WHERE ModulesContentPages_Id = '${key}' AND Category ='${category}'
          ORDER BY OrderId`
    } else {
      postsQuery = `SELECT *
          FROM ModulesContentPagesPosts
          WHERE ModulesContentPages_Id = '${key}'
          ORDER BY OrderId`
    }
    // console.log('postsQuery', postsQuery)
    let posts = await Vue.db.runquery(postsQuery)
    for (let post of posts) {
      let commentsQuery = `SELECT *
          FROM ModulesContentPagesPostsComments AS PostsComments
          WHERE PostsComments.ModulesContentPagesPosts_Id = '${post.Id}'
          ORDER BY CommentDate IS NULL OR CommentDate ='' DESC, CommentDate DESC`
      post.PostComments = await Vue.db.runquery(commentsQuery)
      contnetPageInfo.Posts.push(post)
    }
    contentPages.push(contnetPageInfo)
  }
  return contentPages
}

export const mergeModulesContentPages = async(payload) => {
  await Vue.db.merge(ModuleInfo.Tables.ModulesContentPages, payload,
    ModuleInfo.Primarykey.Id)
}
export const mergeModulesContentPagesPosts = async(payload) => {
  payload.forEach(contentPage => {
    contentPage.Posts.forEach(async(post) => {
      await Vue.db.merge(ModuleInfo.Tables.ModulesContentPagesPosts, post,
        ModuleInfo.Primarykey.Id)
        await Vue.db.merge(ModuleInfo.Tables.ModulesContentPagesPostsComments, post.PostComments,
        ModuleInfo.Primarykey.Id)
    })
  })
}
export const mergeModulesContentPagesPostsComments = async(payload) => {
  await Vue.db.merge(ModuleInfo.Tables.ModulesContentPagesPostsComments, payload,
    ModuleInfo.Primarykey.Id)
}
export const mergeUserActionQueue = async(payload) => {
  await Vue.db.merge(ModuleInfo.Tables.UserActionQueue, payload,
    ModuleInfo.Primarykey.Id)
}
export const mergeReportingUserLikes = async(payload) => {
  await Vue.db.merge(ModuleInfo.Tables.ReportingUserLikes, payload,
    ModuleInfo.Primarykey.Id)
}

export const selectUserActionQueue = () => {
  let result = Vue.db.fetchRows(ModuleInfo.Tables.UserActionQueue)
  return result
}

export const selectModulesImageGalleries = async(key) => {
  let result = await Vue.db.contitionalSelect(ModuleInfo.Tables.ModulesImageGalleries,
    ModuleInfo.Primarykey.SubscriptionModule_Id, key)
  return result
}

export const selectModulesImageGalleriesAlbums = async(key, category) => {
  let galleries = []
  // let categoryQuery = `SELECT Id, Category
  //   FROM ModulesImageGalleriesAlbums
  //   WHERE ModulesImageGalleries_Id = '${key}' GROUP BY Category`
  // let categories = await Vue.db.runquery(categoryQuery)
  let categories = []
  if (!Helper.IsNullOrEmpty(category)) {
    categories = JSON.parse(category)
  } else {
    let categoryQuery = `SELECT Category FROM ModulesImageGalleriesAlbums WHERE ModulesImageGalleries_Id = '${key}' GROUP BY Category`
    let categoryList = await Vue.db.runquery(categoryQuery)
    for (let category of categoryList) {
      categories.push(category.Category)
    }
    if(categories.length === 0) {
      categories.push('')
    }
  }
  // console.log('categories', categories)
  for (let category of categories) {
    let albumInfo = {
      Category: category,
      Albums: []
    }
    let albumQuery = ''
    if (!Helper.IsNullOrEmpty(category)) {
      albumQuery = `SELECT *
          FROM ModulesImageGalleriesAlbums
          WHERE ModulesImageGalleries_Id = '${key}' AND Category ='${category}'
          ORDER BY OrderId`
    } else {
      albumQuery = `SELECT *
          FROM ModulesImageGalleriesAlbums
          WHERE ModulesImageGalleries_Id = '${key}' ORDER BY OrderId`
    }
    // console.log('albumQuery', albumQuery)
    let albums = await Vue.db.runquery(albumQuery)
    for (let album of albums) {
      let imageQuery = `SELECT AlbumImage.Id,AlbumImage.RowCreated,AlbumImage.RowUpdated,
      AlbumImage.RowDeleted,AlbumImage.OrderId,AlbumImage.Description,
      AlbumImage.Image,AlbumImage.IsLiked,AlbumImage.Likes
          FROM ModulesImageGalleriesAlbumsImages AS AlbumImage
          WHERE AlbumImage.ModulesImageGalleriesAlbums_Id = '${album.Id}'
          ORDER BY OrderId`
      album.Images = await Vue.db.runquery(imageQuery)
      albumInfo.Albums.push(album)
    }
    galleries.push(albumInfo)
  }
  return galleries
}

export const mergeModulesCustomCode = async(payload) => {
  await Vue.db.merge(ModuleInfo.Tables.ModulesCustomCode, payload,
    ModuleInfo.Primarykey.Id)
}
export const selectModulesCustomCode = async(key) => {
  let query = `SELECT * FROM ${ModuleInfo.Tables.ModulesCustomCode} WHERE ${ModuleInfo.Primarykey.SubscriptionModule_Id} = ${key}`
  let result = await Vue.db.runquery(query)
  return result
}

export const mergeModulesChat = async(payload) => {
  await Vue.db.merge(ModuleInfo.Tables.ModulesChats, payload,
    ModuleInfo.Primarykey.Id)
}

export const selectModulesChat = async(key) => {
  let query = `SELECT * FROM ${ModuleInfo.Tables.ModulesChats} WHERE ${ModuleInfo.Primarykey.SubscriptionModule_Id} = ${key}`
  let result = await Vue.db.runquery(query)
  return result
}

export const mergeModulesFacebook = async(payload) => {
  await Vue.db.merge(ModuleInfo.Tables.ModulesFacebook, payload,
    ModuleInfo.Primarykey.Id)
}

export const selectModulesFacebook = async(key) => {
  let query = `SELECT * FROM ${ModuleInfo.Tables.ModulesFacebook} WHERE ${ModuleInfo.Primarykey.SubscriptionModule_Id} = ${key}`
  let result = await Vue.db.runquery(query)
  return result
}
export const mergeModulesTwitter = async(payload) => {
  await Vue.db.merge(ModuleInfo.Tables.ModulesTwitter, payload,
    ModuleInfo.Primarykey.Id)
}

export const selectModulesTwitter = async(key) => {
  let query = `SELECT * FROM ${ModuleInfo.Tables.ModulesTwitter} WHERE ${ModuleInfo.Primarykey.SubscriptionModule_Id} = ${key}`
  let result = await Vue.db.runquery(query)
  return result
}
export const mergeModulesInstagram = async(payload) => {
  await Vue.db.merge(ModuleInfo.Tables.ModulesInstagram, payload,
    ModuleInfo.Primarykey.Id)
}

export const selectModulesInstagram = async(key) => {
  let query = `SELECT * FROM ${ModuleInfo.Tables.ModulesInstagram} WHERE ${ModuleInfo.Primarykey.SubscriptionModule_Id} = ${key}`
  let result = await Vue.db.runquery(query)
  return result
}
export const mergeModulesWebsite = async(payload) => {
  await Vue.db.merge(ModuleInfo.Tables.ModulesWebsite, payload,
    ModuleInfo.Primarykey.Id)
}
export const selectModulesWebsite = async(key) => {
  let query = `SELECT * FROM ${ModuleInfo.Tables.ModulesWebsite} WHERE ${ModuleInfo.Primarykey.SubscriptionModule_Id} = ${key}`
  let result = await Vue.db.runquery(query)
  return result
}
export const mergeModulesPdf = async(payload) => {
  await Vue.db.merge(ModuleInfo.Tables.ModulesPDF, payload,
    ModuleInfo.Primarykey.Id)
}
export const selectModulesPdf = async(key) => {
  let query = `SELECT * FROM ${ModuleInfo.Tables.ModulesPDF} WHERE ${ModuleInfo.Primarykey.SubscriptionModule_Id} = ${key}`
  let result = await Vue.db.runquery(query)
  return result
}
export const mergeModulesYoutube = async(payload) => {
  await Vue.db.merge(ModuleInfo.Tables.ModulesYoutube, payload,
    ModuleInfo.Primarykey.Id)
}

export const selectModulesYoutube = async(key) => {
  let query = `SELECT * FROM ${ModuleInfo.Tables.ModulesYoutube} WHERE ${ModuleInfo.Primarykey.SubscriptionModule_Id} = ${key}`
  let result = await Vue.db.runquery(query)
  return result
}

export const mergeModulesRssFeed = async(payload) => {
  await Vue.db.merge(ModuleInfo.Tables.ModulesRSSFeed, payload,
      ModuleInfo.Primarykey.Id)
}

export const selectModulesRssFeed = async(key) => {
  let query = `SELECT * FROM ${ModuleInfo.Tables.ModulesRSSFeed} WHERE ${ModuleInfo.Primarykey.SubscriptionModule_Id} = ${key}`
  let result = await Vue.db.runquery(query)
  return result
}

export const mergeModulesRadioStream = async(payload) => {
  await Vue.db.merge(ModuleInfo.Tables.ModulesRadioStream, payload,
      ModuleInfo.Primarykey.Id)
}

export const selectModulesRadioStream = async(key) => {
  let query = `SELECT * FROM ${ModuleInfo.Tables.ModulesRadioStream} WHERE ${ModuleInfo.Primarykey.SubscriptionModule_Id} = ${key}`
  let result = await Vue.db.runquery(query)
  return result
}


export const mergeModulesForms = async(payload) => {
  // console.log('mmform', ModuleInfo.Tables.ModulesForms, payload)
  await Vue.db.merge(ModuleInfo.Tables.ModulesForms, payload,
      ModuleInfo.Primarykey.Id)
}

export const selectModulesForms = async(key) => {
  let query = `SELECT * FROM ${ModuleInfo.Tables.ModulesForms} WHERE ${ModuleInfo.Primarykey.SubscriptionModule_Id} = ${key}`
  let result = await Vue.db.runquery(query)
  return result
}

export const mergeModulesImageGalleries = async(payload) => {
  await Vue.db.merge(ModuleInfo.Tables.ModulesImageGalleries, payload,
    ModuleInfo.Primarykey.Id)
}

export const mergeModulesImageGalleriesAlbums = async(payload) => {
  payload.forEach(galleries => {
    galleries.Albums.forEach(async(album) => {
      await Vue.db.merge(ModuleInfo.Tables.ModulesImageGalleriesAlbums, album,
        ModuleInfo.Primarykey.Id)
        await Vue.db.merge(ModuleInfo.Tables.ModulesImageGalleriesAlbumsImages, album.Images,
        ModuleInfo.Primarykey.Id)
    })
  })
}

export const dropUserActionQueueEntry = (key) => {
  Vue.db.deleteByStringId(ModuleInfo.Tables.UserActionQueue,
    ModuleInfo.Primarykey.Id, key)
}

export const mergeUserActionQueueEntryWithModuleContentPagesTables = async(processedPayload) => {
  await Vue.db.updateModulesContentPagesPostsLike(processedPayload.Payload.tableName, processedPayload.Payload.keyColumn, processedPayload.Payload, processedPayload.Payload.Reference_Id)
}

export const mergeUserActionQueueEntryWithModuleImageGalleriesTables = async(processedPayload) => {
  await Vue.db.updateModulesImageGalleriesPostsLike(processedPayload.Payload.tableNameArray, processedPayload.Payload.keyColumn, processedPayload.Payload, processedPayload.Payload.Reference_Id)
}

export const mergeUserActionQueueEntryWithModulesRadioStreamTables = async(processedPayload) => {
  await Vue.db.updateModulesRadioStreamLike(processedPayload.Payload.tableName, processedPayload.Payload.keyColumn, processedPayload.Payload, processedPayload.Payload.Reference_Id)
}



// WEBPACK FOOTER //
// ./src/dbQuery/dbInteractions.js